import { createSlice } from "@reduxjs/toolkit";

const MEMBER_INFO = {
  relation: 0,
  birthDate: "",
  birthProvinceId: 0,
  job: "",
  educationTypeCode: "",
};

const initialState = {
  familyMembers: [
    {
      relation: 3,
      label: "خواهر",
    },
    {
      relation: 4,
      label: "برادر",
    },
  ],
  isDataChanged: false,
  isNew: true,
  reloadPage: false,
  data: {
    beliefTypeCode: "",
    livingConditionParentsCode: "",
    economicLevelCode: "",
    economicDescription: "",
    residenceTypeCode: "",
    fatherLifeTypeCode: "",
    motherLifeTypeCode: "",
    motherClothingTypeCode: "",
    familyMembers: [
      { ...MEMBER_INFO, relation: 1 },
      { ...MEMBER_INFO, relation: 2 },
    ],
  },
};

export const FamilyInformationSlice = createSlice({
  name: "FamilyInformation",
  initialState,
  reducers: {
    updateFamilyInformationData: (state, { payload: { key, value, required } }) => {
      state.isDataChanged = true;
      state.data[key] = value;
      if (value.length === 0) {
        if (required) {
          state.data[key] = value;
        } else {
          delete state.data[key];
        }
      } else {
        state.data[key] = value;
      }
    },
    setIsDataChangedForFamily: (state, { payload }) => {
      state.isDataChanged = payload;
    },
    setIsNewForFamilyInformation: (state, { payload }) => {
      state.isNew = payload;
    },
    setFamilyInformationData: (state, { payload }) => {
      state.isDataChanged = false;
      state.isNew = false;
      state.data = payload;
    },
    addNewFamilyMember: (state) => {
      state.isDataChanged = true;
      state.data.familyMembers.push({ ...MEMBER_INFO, relation: 3 });
    },
    deleteFamilyMember: (state, { payload: index }) => {
      state.isDataChanged = true;
      state.data.familyMembers.splice(index, 1);
    },
    editFamilyMember: (state, { payload: { index, fieldName, value } }) => {
      state.isDataChanged = true;
      state.data.familyMembers[index][fieldName] = value;
    },
    editFamilyMemberRelation: (state, { payload: { index, relation } }) => {
      state.isDataChanged = true;
      state.data.familyMembers[index]["relation"] = parseInt(relation);
    },
    clearFamilyInformationData: () => initialState,
    setReloadFamilyInformationData: (state, { payload }) => {
      state.reloadPage = payload;
    },
  },
});

export const {
  updateFamilyInformationData,
  setIsNewForFamilyInformation,
  setFamilyInformationData,
  addNewFamilyMember,
  editFamilyMember,
  editFamilyMemberRelation,
  deleteFamilyMember,
  setIsDataChangedForFamily,
  clearFamilyInformationData,
  setReloadFamilyInformationData,
} = FamilyInformationSlice.actions;

export const FamilyInformationReducer = FamilyInformationSlice.reducer;
